import React, { ReactNode } from "react";
import cls from "classnames";
import { Popup } from "@al/akui-mobile";
import { PopupProps } from "antd-mobile/es/components/popup";

import Iconfont from "~/components/ui/Iconfont";

import styles from "./styles.scss";

export interface HalfPopupProps extends PopupProps {
  title?: ReactNode;
  subTitle?: ReactNode;
  showBackIcon?: boolean;
  headerTextAlign?: "left" | "center";
  children?: ReactNode;
  onClose?: () => void;
  contentClassName?: string;
  titleClassName?: string;
  onBack?: () => void;
}

const HalfPopup = ({
  title,
  subTitle,
  headerTextAlign = "center",
  showBackIcon,
  children,
  className,
  onClose,
  contentClassName,
  titleClassName,
  onBack,
  ...rest
}: HalfPopupProps): JSX.Element => {
  return (
    <Popup className={cls(styles.half_popup, className)} {...rest}>
      {title ? (
        <div
          className={cls(
            styles.half_popup_header,
            headerTextAlign === "left" && styles.half_popup_header_align_left,
            showBackIcon && styles.half_popup_header_has_back_icon
          )}
        >
          {showBackIcon ? (
            <div onClick={onBack}>
              <Iconfont name="back" className={styles.half_popup_header_back_icon} />
            </div>
          ) : null}
          <div className={cls(styles.half_popup_title, titleClassName)}>{title}</div>
          {subTitle && <div className={styles.half_popup_sub_title}>{subTitle}</div>}
        </div>
      ) : null}
      <div className={cls(styles.half_popup_content, contentClassName)}>{children}</div>
      <Iconfont name="close" className={styles.half_popup_close_icon} onClick={onClose} />
    </Popup>
  );
};

export default HalfPopup;
